<template>
  <div>
    <el-tabs v-model="activeName" type="border-card" class="mt-2">
      <el-tab-pane
        :label="$l('detail_tab_pane_base_info') || '基本信息'"
        name="base"
        lazy
      >
        <BaseForm
          :proofingCode="params.proofingCode"
          :disabled="disabled"
          :isAddOperation="isAddOperation"
          ref="baseForm"
        />
      </el-tab-pane>
      <el-tab-pane
        :label="$l('detail_tab_pane_sample_info') || '样品信息'"
        name="sampl"
        lazy
        :disabled="isAddOperation"
      >
        <SampleTable :proofingCode="params.proofingCode" :disabled="disabled" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import BaseForm from './components/base-form'
import SampleTable from './components/sample-table'

export default {
  name: 'sample-proofing-detail',
  components: { BaseForm, SampleTable },
  data() {
    return {
      activeName: 'base',
    }
  },
  computed: {
    params() {
      return this.$route.params
    },
    pageType() {
      return this.params.pageType
    },
    pageHeader() {
      const types = {
        edit: this.$l('page_header_title_edit') || '编辑样品依赖书信息',
        add: this.$l('page_header_title_add') || '添加样品依赖书信息',
        detail: this.$l('page_header_title_detail') || '样品依赖信息详情',
      }
      return types[this.pageType]
    },
    disabled() {
      return this.pageType === 'detail'
    },
    isAddOperation() {
      return this.pageType === 'add'
    },
  },
}
</script>
